import { resolveCreativeDecisionsUiState } from './creativeDecisionsFeatureState';

export const CREATIVE_DECISIONS_UI_STATE = resolveCreativeDecisionsUiState(import.meta.env);
export const CREATIVE_DECISIONS_UI_ENABLED = CREATIVE_DECISIONS_UI_STATE.enabled;
